import { useColorScheme, useLocales } from "@/lib/hooks";
import { AsideMenuItemLinkType, BgColorType } from "@/lib/types";
import { CSSProperties } from "react";
import { NavLink, useLocation } from "react-router";

type PropsType = {
  bgColor?: BgColorType;
  item: AsideMenuItemLinkType;
};

export default function AsideNavLink({ bgColor, item }: PropsType) {
  const l = useLocales();
  const location = useLocation();
  const { colorScheme } = useColorScheme();

  const isActive = (to: string) => location.pathname.startsWith(to);
  const active = isActive(item.to);

  const tabStyle = (active: boolean): CSSProperties => ({
    backgroundColor: active
      ? "var(--color-background-brand)"
      : bgColor
        ? `var(--color-background-${bgColor})`
        : colorScheme === "light"
          ? "var(--color-background-elevated)"
          : "var(--color-background-frame)",
    padding: "var(--spacing-md)",
    width: "fit-content",

    borderRadius: "var(--border-radius-sm) var(--border-radius-sm) 0 0",

    color: active
      ? colorScheme === "light"
        ? "var(--color-text-always-light)"
        : "var(--color-text-always-dark)"
      : "var(--color-text-primary)",
    fontSize:
      "clamp(var(--font-size-xs), 0.5rem + 0.75vw, var(--font-size-navbar-item))",
    fontWeight: active ? 600 : 400,
    textDecoration: "none",

    overflow: "hidden",
    textOverflow: "ellipsis",
  });

  return (
    <NavLink
      key={item.id}
      to={item.to}
      aria-current={active ? "page" : undefined}
      style={tabStyle(active)}
    >
      {l(item.title)}
    </NavLink>
  );
}
